<template>
  <div v-if="sokFacets" class="searchfacets">
    <Collapse
      :id="'searchfacets-collapse'"
      :open="!isDesktopView"
      :iconTypeOpen="'fa-chevron-up'"
      :iconTypeClosed="'fa-chevron-down'"
    >
      <template #button-content-after-icon>
        <span id="searchfacets-collapse-rubrik">
          {{ texts.flerFilter }}
        </span>
      </template>
      <template #content-beside-button>
        <ClearFacetsFacetsBtn
          :text="texts.rensaFilter"
          :anyFacetsSelected="anyFacetsSelected()"
          @clearSelectedFacets="clearSelectedFacets"
        ></ClearFacetsFacetsBtn
      ></template>
      <template #collapse-content>
        <div class="d-flex flex-wrap">
          <div class="searchfacets-dropdown" v-if="showFirstFacetAsDropdown">
            <span class="legend">{{ texts.intresseomraden }}</span>
            <Dropdown
              :iconTypeOpen="'fa-chevron-up'"
              :iconTypeClosed="'fa-chevron-down'"
            >
              <template #button-content-before-icon>
                <span class="placeholder">{{ texts.valjIntresseomrade }}</span>
              </template>
              <template #dropdown-content>
                <SearchFacetsFieldset
                  :legend="texts.intresseomraden"
                  :facets="firstFacetValue"
                  :selectedList="getSelectedList(firstFacetKey)"
                  :facetName="firstFacetKey"
                  :texts="texts"
                  :hideLegend="true"
                  @facetSelected="facetSelected"
                ></SearchFacetsFieldset>
              </template>
            </Dropdown>
          </div>
          <SearchFacetsFieldset
            v-for="([key, facets]) in restFacets"
            :key="key"
            :legend="getLegend(key)"
            :facets="facets"
            :selectedList="getSelectedList(key)"
            :facetName="key"
            :texts="texts"
            @facetSelected="facetSelected"
          ></SearchFacetsFieldset>
        </div>
        <div class="searchfacets-collapse-buttons">
          <button
            class="collapse-button"
            type="button"
            @click="close"
            aria-expanded="true"
            aria-controls="searchfacets-collapse"
          >
            <Icon :type="'fa-chevron-up'" />
            <span>{{ texts.farreFilter }}</span>
          </button>
          <ClearFacetsFacetsBtn
            :text="texts.rensaFilter"
            :anyFacetsSelected="anyFacetsSelected()"
            @clearSelectedFacets="clearSelectedFacets"
          ></ClearFacetsFacetsBtn>
        </div>
      </template>
    </Collapse>
    <div v-if="anyFacetsSelected()" class="selectedfacets">
      <SearchFacetsSelected
        :selectedFacets="selectedFacets"
        :texts="texts"
        @removeSelectedFacet="removeSelectedFacet"
      ></SearchFacetsSelected>
    </div>
  </div>
</template>
<script>
import Icon from "../../image/icon.vue";
import Collapse from "../../bootstrap/collapse.vue";
import Dropdown from "../../bootstrap/dropdown.vue";
import SearchFacetsFieldset from "./searchfacetsfieldset.vue";
import SearchFacetsSelected from "./searchfacetsselected.vue";
import ClearFacetsFacetsBtn from "./clearfacetsbtn.vue";

export default {
  name: "SearchFacets",
  props: {
    showFirstFacetAsDropdown:Boolean,
    selectedFacets: Object,
    texts: Object,
    sokFacets: Object,
  },
  data: function () {
    return {
      isDesktopView: true,
      selectedList: { ...this.selectedFacets },
      breakpoint: parseInt(
        getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-xl")
      ),
    };
  },
  components: {
    Icon,
    Collapse,
    Dropdown,
    SearchFacetsFieldset,
    SearchFacetsSelected,
    ClearFacetsFacetsBtn,
  },
  created() {
    this.IsDesktop();
  },
  mounted() {
    window.addEventListener("resize", this.IsDesktop);
  },
  unmounted() {
    window.removeEventListener("resize", this.IsDesktop);
  },
  computed: {
    firstFacetKey() {
      return Object.keys(this.sokFacets)[0];
    },
    firstFacetValue() {
      return this.sokFacets[this.firstFacetKey];
    },
    restFacets() {
      if (this.showFirstFacetAsDropdown) {
        return Object.entries(this.sokFacets).slice(1);
      } else {
        return Object.entries(this.sokFacets);
      }
    },
  },
  methods: {
    facetSelected(selected, facetnamn) {
      const cleanedFacetName = facetnamn.replace("utb_tillfallen/", "");
      this.$emit("facetSelected", selected, cleanedFacetName);
    },
    getLegend(key) {
      if (!key) return key;
      const cleanedFacetName = key.replace("utb_tillfallen/", "");
      return this.texts[cleanedFacetName] || key; // Default to key if no specific legend is defined
    },
    getSelectedList(key) {
      if (!key) return key;
      const cleanedKey = key.replace("utb_tillfallen/", "");
      return this.selectedList[cleanedKey] || [];
    },
    IsDesktop() {
      this.isDesktopView = window.innerWidth >= this.breakpoint;
    },
    anyFacetsSelected() {
      return Object.values(this.selectedFacets).some(
        (values) => values.length > 0
      );
    },
    clearSelectedFacets() {
      this.$emit("clearSelectedFacets"); // Clear all selected facets
    },
    removeSelectedFacet(facetName, value) {
      this.$emit("removeSelectedFacet", facetName, value);
    },
    close() {
      var collapseBtn = document.getElementById("searchfacets-collapse-button");
      if (collapseBtn) {
        collapseBtn.click(); // Trigger the collapse button to close the collapse
      }
    },
  },
  watch: {
    selectedFacets: {
      deep: true,
      handler(newVal) {
        this.selectedList = { ...newVal };
      },
    },
  },
};
</script>
